import { createSlice } from '@reduxjs/toolkit';

const initialDepartmentState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    departmentForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const departmentSlice = createSlice({
    name: 'department',
    initialState: initialDepartmentState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // getDepartmentById
        departmentFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.departmentForEdit = action.payload.departmentForEdit;
        },
        // findDepartment
        departmentsFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        departmentReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

